import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabMenuModule } from 'primeng/tabmenu';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { AureusModule } from '@arc/aureus';
import { ApplicationNavigationComponent } from './application-navigation/application-navigation.component';
import { ApplicationNavigationContainerComponent } from './application-navigation/application-navigation.container.component';
import { CrossSellComponent } from './cross-sell/cross-sell.component';
import { InvoicingCrossSellComponent } from './cross-sell/invoicing-cross-sell/invoicing-cross-sell.component';
import { PaymentsCrossSellComponent } from './cross-sell/payments-cross-sell/payments-cross-sell.component';
import { CashAppCrossSellComponent } from './cross-sell/cash-app-cross-sell/cash-app-cross-sell.component';
import { CollectionsCrossSellComponent } from './cross-sell/collections-cross-sell/collections-cross-sell.component';
import { CreditCrossSellComponent } from './cross-sell/credit-cross-sell/credit-cross-sell.component';
import { DisputesCrossSellComponent } from './cross-sell/disputes-cross-sell/disputes-cross-sell.component';
import { ArcWidgetsModule } from '@arc/arc-shared-frontend';

@NgModule({
  declarations: [
    ApplicationNavigationComponent,
    ApplicationNavigationContainerComponent,
    CrossSellComponent,
    InvoicingCrossSellComponent,
    PaymentsCrossSellComponent,
    CashAppCrossSellComponent,
    CollectionsCrossSellComponent,
    CreditCrossSellComponent,
    DisputesCrossSellComponent
  ],
  imports: [
    CommonModule,
    AureusModule,
    TabMenuModule,
    OverlayPanelModule,
    ArcWidgetsModule
  ],
  exports: [
    ApplicationNavigationComponent,
    ApplicationNavigationContainerComponent,
    InvoicingCrossSellComponent,
    PaymentsCrossSellComponent,
    CashAppCrossSellComponent,
    CollectionsCrossSellComponent,
    CreditCrossSellComponent,
    DisputesCrossSellComponent
  ]
})
export class NavigationModule {}
